/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Abilities_Filter_EmptyInputs */



/**
* | output |
* | --- |
* | "No abilities match your filter." |
*
* @param {Agent_Builder_Abilities_Filter_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_abilities_filter_empty = /** @type {((inputs?: Agent_Builder_Abilities_Filter_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Abilities_Filter_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Fähigkeiten entsprechen dem Filter.")
	return /** @type {LocalizedString} */ ("No abilities match your filter.")
});